<div class="form">
  <form [formGroup]="sampleEditForm">
    <p class="heading" i18n>Edit</p>
    <div class="form__fields__container">
      <!-- <app-input
        [formCntlName]="sampleEditForm.get('userName')"
        [inputType]="'text'"
        [label]="'User'"
        [placeholder]="'user name'"
      ></app-input> -->
      <app-input
        [formCntlName]="sampleEditForm.get('SampleName')"
        [inputType]="'text'"
        [label]="'Sample Name'"
        [placeholder]="'sample name'"
      ></app-input>
      <mat-error class="error" i18n *ngIf="sampleEditForm.get('SampleName')?.hasError('maxlength')">
        Sample name cannot be longer than 256 characters
      </mat-error>
      <mat-error class="error" i18n *ngIf="sampleEditForm.get('SampleName')?.hasError('required')">
        Sample name is required
      </mat-error>
      <mat-error class="error" i18n *ngIf="sampleEditForm.get('SampleName')?.hasError('whitespace')">
        Input cannot be just spaces.
      </mat-error>
      <div class="edit-textarea">
        <label class="input-label" i18n>Sample Description</label>
        <textarea formControlName="SampleDescription" placeholder="Sample Description" rows="3" i18n></textarea>
      </div>
      <mat-error class="error" i18n *ngIf="sampleEditForm.get('SampleDescription')?.hasError('maxlength')">
        Sample Description cannot be longer than 1024 characters
      </mat-error>
      <mat-error class="error" i18n *ngIf="sampleEditForm.get('SampleDescription')?.hasError('whitespace')">
        Input cannot be just spaces.
      </mat-error>
      <div class="group-select-container" style="margin-bottom: 1rem">
        <app-searchable-multi-select
          [label]="'Project/Group(s)'"
          [disabledOptions]="disabledGroupOptions"
          [placeholder]="groupOptions.length > 0 ? 'Select Groups' : 'No groups to remove'"
          [options]="groupOptions"
          [formControlName]="'groups'"
          [multiple]="true"
        ></app-searchable-multi-select>
      </div>
    </div>
    <div class="form__btn__container">
      <app-buttons
        [isDisabled]="false"
        [name]="buttonCancel"
        [arialLabel]="arialLabel"
        [buttonType]="btnMat"
        [buttonStyle]="btnStyleText"
        (buttonClickEvent)="closePopup()"
      ></app-buttons>
      <app-buttons
        [isDisabled]="
          !sampleEditForm.valid || (!sampleEditForm.dirty && sampleEditForm.get('groups')?.pristine) || isSubmitting
        "
        [name]="buttonSave"
        [buttonType]="btnMatFlat"
        [buttonStyle]="
          !sampleEditForm.valid || (!sampleEditForm.dirty && sampleEditForm.get('groups')?.pristine) || isSubmitting
            ? btnStyleFilledSmallDisabled
            : btnStyleFilledSmall
        "
        (buttonClickEvent)="onEditSubmit()"
      ></app-buttons>
    </div>
  </form>
</div>
